import {get} from "../../../Utils/Crypto";
import * as Crypto from "../../../Utils/Crypto";

const DEVELOPMENT_MODE = window.location.href.includes("localhosts") || window.location.href.includes('vendor.dev.eka.io');
const UAT_MODE = window.location.href.includes("localhosts") || window.location.href.includes('vendor-uat.dice.tech');
const SANDBOX_MODE = window.location.href.includes("localhosts") || window.location.href.includes('vendor-sandbox.dice.tech');
const JKC_MODE = window.location.href.includes('vendor-uat.jkyms.com');
const JKC_PROD_MODE = window.location.href.includes('vendor.jkyms.com');
const TRIDENT_MODE = window.location.href.includes('vendor-trident.dice.tech');


const PROD_MODE = window.location.href.includes('localhosts') || window.location.href.includes('https://vendor-staging.netlify.app/');;

let api, luna, token, track;

if (DEVELOPMENT_MODE) {
	api = "https://api.dev.eka.io/vendor/";
	track = "https://track.expanso.in/vendor/";
	luna = "luna-staging";
	token = () => get("refresh_token");
} else if (PROD_MODE) {
	api = "https://api.prod.eka.io/vendor/";
    track = "https://track.expanso.in/vendor/";
    luna = "luna";
    token = () => get("refresh_token");
} else if (SANDBOX_MODE) {
	api = "https://api-uat-sandbox.eka.io/vendor/";
	track = "https://track.expanso.in/vendor/";
	luna = "luna";
	token = () => get("refresh_token");
}  else if(JKC_MODE) {
	api = 'https://api-uat.jkyms.com/vendor/';
} else if(JKC_PROD_MODE) {
	api = 'https://api.jkyms.com/vendor/';
} else if(TRIDENT_MODE) {
	api = "https://trident-test.eka.io/vendor/";
}

else {
	api = "https://heimdall.eka.io/vendor/";
	luna = "luna";
	token = () => get("refresh_token");
}

if(window.location.href.includes('dev-vendor-dice-tech')) {
	api = 'https://integration.dev.eka.io/vendor/'
}

if(window.location.href.includes('vendor-uat.dice.tech') || window.location.href.includes('localhosts')) {
	api = 'https://dice-uat.eka.io/vendor/'
}

track = "https://track.eka.io/vendor/";

const getUploadUrl = () => {
	// const token = Crypto.get('token');
	// var base64Url = token.split('.')[1];
	// var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	// var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
	// 	return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	// }).join(''));
	// let json = JSON.parse(jsonPayload);
	if(DEVELOPMENT_MODE){
		return `https://file.dev.eka.io/apis/v4/vendor/upload`
	}
	else if(SANDBOX_MODE){
		//api not deployed yet
		return `https://uat-file.eka.io/apis/v4/vendor/upload`
	} else if(JKC_MODE) {
		return `https://upload-uat.jkyms.com/apis/v4/vendor/upload`
	} else if(JKC_PROD_MODE) {
		return `https://upload.jkyms.com/apis/v4/vendor/upload`
	}
	else{
		return `https://file.eka.io/apis/v4/vendor/upload`
	}
}

const getVendorBaseUrl = () => {
	const token = Crypto.get('token');	
	var base64Url = token.split('.')[1];
	var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));
	let json = JSON.parse(jsonPayload);	
	if(DEVELOPMENT_MODE) {
		return api
	}
	if(JKC_MODE) {
		return api;
	}
	if(JKC_PROD_MODE) {
		return api;
	}
	if(UAT_MODE) {		
		return api;
	}
	if(SANDBOX_MODE) {
		return api
	}
	if(PROD_MODE) {
		return api
	}
	if(!json.origin){
		return "https://heimdall.eka.io/vendor/";
	}
	return json.origin + "vendor/";
};

export {
	api, luna, DEVELOPMENT_MODE, token, track, UAT_MODE, getVendorBaseUrl, getUploadUrl,
	SANDBOX_MODE,JKC_MODE,JKC_PROD_MODE
	
}
